exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".monaco-jumpy{position:absolute;font-size:.7em;font-family:consolas,menlo,monospace;font-weight:700;color:#333;background:#fff;opacity:.9;border-radius:25%;padding-left:2px;padding-right:2px;padding-top:1px;z-index:1000}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/app/monaco/addons/jumpy.css
 ** module id = 191
 ** module chunks = 0
 **/